// See console-extensions.json instead
export default [];
